import React from 'react';

import RIQPageError from './RIQPageError.jsx';

// React doesn't support error boundaries with function components yet, so this is an old school class-based Component.
export default class RIQErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false
        };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }

    // eslint-disable-next-line class-methods-use-this
    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        RivalIQ.errors.script.reportError([
            'Uncaught error',
            window.location,
            error.toString(),
            JSON.stringify(error),
            error.stack
        ].join('; '), error);
    }

    render() {
        if (this.state.hasError) {

            return (
                <RIQPageError />
            );
        }

        return this.props.children;
    }
}
